import React from 'react'

// Hooks
import { useGlobal } from '../../../../../hooks'

import { AdministrationList } from '../../../List'

// Queries
import {
  DELETE_CHANGE_REFILL_MOTIVES,
  LIST_CHANGE_REFILL_MOTIVES,
} from './queries'

const queries = {
  list: LIST_CHANGE_REFILL_MOTIVES,
  delete: DELETE_CHANGE_REFILL_MOTIVES,
}

const AdministrationListLubricantChangeRefillMotives = () => {
  const [{ me }] = useGlobal()

  const no = ![1, 2].includes(me.id_role)

  return (
    <AdministrationList
      queries={queries}
      noCreate={no}
      noUpdate={no}
      noDelete={no}
    />
  )
}

export default AdministrationListLubricantChangeRefillMotives
